module.exports = {
	"header": "Oups! 500 - Erreur interne du serveur",
	"goBack": "Retour au site principal",
	"ln1": "Désolé... Ce n'est pas vous. C'est nous.",
	"ln2": "Il y a un problème interne du serveur.",
	"ln3": "S'il vous plaît, essayez encore ou contactez-nous à <supportEmail>$t(500::supportEmail)</supportEmail>",
	"supportEmail": "support@auctionex.com"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/500.json5
// module id = 1968
// module chunks = 6